export const GET_BIRTH_DATE_LIST = 'GET_BIRTH_DATE_LIST';
export const GET_BIRTH_DATE_LIST_SUCCESS = 'GET_BIRTH_DATE_LIST_SUCCESS';
export const GET_BIRTH_DATE_LIST_FAIL = 'GET_BIRTH_DATE_LIST_FAIL';